import React from 'react';
import {useClaimState} from '../components/claim';
import useQuery from './use-query';
import {useSettingsState} from '../components/settings';

const useClaimStateEx = () => {
    const {defaultServiceId} = useSettingsState();
    const {serviceId = defaultServiceId} = useQuery();
    const state = useClaimState();
    return React.useMemo(() => state.filter(e => e.serviceId === serviceId), [state, serviceId]);
};

export default useClaimStateEx;
